import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import qs from 'qs'

export default function useSearchParams() {
  const location = useLocation()

  const params = useMemo(() => (
    qs.parse(location.search.substr(1))
  ), [location.search])

  return params
}
